// 작업 ID 생성 및 관리 유틸리티

// UUID 생성 함수 (또는 다른 고유 ID 생성 방법)
export function generateWorkId() {
  return 'work_' + Date.now() + '_' + Math.random().toString(36).substr(2, 9);
}

// localStorage에 활성 작업 ID 저장
export function addActiveWork(workId) {
  const activeWorks = JSON.parse(localStorage.getItem('activeWorks') || '[]');
  if (!activeWorks.includes(workId)) {
    activeWorks.push(workId);
    localStorage.setItem('activeWorks', JSON.stringify(activeWorks));
  }
}

// 작업 완료 시 제거
export function removeActiveWork(workId) {
  const activeWorks = JSON.parse(localStorage.getItem('activeWorks') || '[]');
  const filtered = activeWorks.filter(id => id !== workId);
  localStorage.setItem('activeWorks', JSON.stringify(filtered));
}

// 모든 활성 작업 ID 가져오기
export function getActiveWorks() {
  return JSON.parse(localStorage.getItem('activeWorks') || '[]');
}

// 모든 활성 작업 ID 제거
export function clearActiveWorks() {
  localStorage.removeItem('activeWorks');
}

